<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <div class="LineClassPicker">
      <van-cell
        icon="logistics"
        title="路线"
        :value="line.text"
        value-class="infoValue"
      />
      <van-cell
        icon="clock-o"
        title="始发时间"
        :value="lineClassDay.ClassTime"
        value-class="infoValue"
      />
      <van-button type="warning" block @click="showUploadAttachment = true"
        >录入合同图片附件</van-button
      >
      <van-dialog
        v-model="showUploadAttachment"
        show-cancel-button
        @cancel="fileList = []"
        @confirm="uploadAttachment"
      >
        <van-uploader v-model="fileList" multiple :after-read="afterReadImg" />
      </van-dialog>
      <van-cell-group title="合同列表">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLineClassDayContractQuery"
        >
          <van-panel
            v-for="item in ContractList"
            :key="item.GID"
            :title="
              '报备时间:' + $moment(item.CreateTime).format('YYYY-MM-DD HH:mm')
            "
            :desc="'合同编号:' + item.CharteredBusNum"
          >
            <template #header>
              <div style="padding: 10px; font-size: 14px">
                <span style="font-size: 18px"
                  >报备时间：{{
                    $moment(item.CreateTime).format("YYYY-MM-DD HH:mm")
                  }}
                </span>
                <br />
                <span style="color: #888"
                  >合同编号：{{ item.CharteredBusNum }}</span
                >
                <br />
                <span v-if="item.Remark" style="color: red"
                  >错误信息：{{ item.Remark }}</span
                >
              </div>
            </template>
            <div style="padding: 10px; font-size: 14px">
              <span>甲方(包车方):{{ item.CharterPartyName }}</span>
              <br />
              <span>承运企业:{{ item.UserName }}</span>
              <br />
              <span>车牌号集:{{ item.CraNumList }}</span>
              <br />
              <span>乘车人数:{{ item.Passenger }}</span>
              <br />
              <span>从:{{ item.StartPlace }}-->到:{{ item.EndPlace }}</span>
            </div>
            <div slot="footer" style="text-align: end">
              <van-button
                size="small"
                type="default"
                @click="onCopyUrl(item.GID, 1)"
                >复制链接</van-button
              >
              <van-button
                size="small"
                type="info"
                @click="onContractReSend(item.GID)"
                style="margin-left: 20px"
                >重新发送</van-button
              >
              <!-- <van-button
                size="small"
                type="danger"
                @click="onLineClassDayContractDel(item.GID)"
                style="margin-left: 20px"
                >删除</van-button
              > -->
              <van-button
                size="small"
                type="primary"
                @click="onContractView(item.GID)"
                style="margin-left: 20px"
                >预览</van-button
              >
            </div>
          </van-panel>
        </van-list>
      </van-cell-group>
      <van-cell-group title="路单列表">
        <van-list
          v-model="startNodeUploadLoading"
          :finished="startNodeUploadFinished"
          finished-text="没有更多了"
          @load="onLineClassDayStartNodeDataUploadQuery"
        >
          <van-panel
            v-for="item in startNodeUploadList"
            :key="item.GID"
            :title="
              '报备时间:' + $moment(item.CreateTime).format('YYYY-MM-DD HH:mm')
            "
          >
            <template #header>
              <div style="padding: 10px; font-size: 14px">
                <span style="font-size: 18px"
                  >报备时间：{{
                    $moment(item.CreateTime).format("YYYY-MM-DD HH:mm")
                  }}
                </span>
                <br />
                <span style="color: #888"
                  >路单编号：{{ item.XingCheLuDanHao }}</span
                >
                <br />
                <span v-if="item.Remark" style="color: red"
                  >错误信息：{{ item.Remark }}</span
                >
              </div>
            </template>
            <div style="padding: 10px; font-size: 14px">
              <span>行车路单ID:{{ item.WayBillNum }}</span>
              <br />
              <!-- <span>站点名称:{{ item.NodeName }}</span> -->
              <!-- <br /> -->
              <span>车牌号码:{{ item.VehicleNo }}</span>
              <br />
              <br />
              <span>点击右下角预览查看各站点具体信息</span>
            </div>
            <div slot="footer" style="text-align: end">
              <van-button
                size="small"
                type="default"
                @click="onCopyUrl(item.StartNodeGID, 2)"
                >复制链接</van-button
              >
              <van-button
                size="small"
                type="info"
                @click="onStartNodeReSend(item.StartNodeGID)"
                style="margin-left: 20px"
                >重新发送</van-button
              >
              <!-- <van-button
                size="small"
                type="danger"
                @click="onLineClassDayContractDel(item.GID)"
                style="margin-left: 20px"
                >删除</van-button
              > -->
              <van-button
                size="small"
                type="primary"
                @click="onStartNodeView(item.StartNodeGID)"
                style="margin-left: 20px"
                >预览</van-button
              >
            </div>
          </van-panel>
        </van-list>
      </van-cell-group>
      <van-cell-group title="班次附件">
        <van-uploader
          disabled
          v-model="classFileList"
          :deletable="false"
          :show-upload="false"
        />
      </van-cell-group>
    </div>

    <van-dialog
      v-model="showReSend"
      title="您确定要将该合同信息重新发送给司机吗？"
      show-cancel-button
      v-on:confirm="onContractReSendGo"
      v-on:cancel="
        showReSend = false;
        driverTel = null;
        errorMsg = '';
      "
      :before-close="reSendBeforeClose"
    >
      <van-field
        v-model="driverTel"
        placeholder="请输入手机号码,如不填将默认发送给司机"
        :error-message="errorMsg"
      />
    </van-dialog>

    <van-dialog
      v-model="showStartNodeReSend"
      title="您确定要将该路单信息重新发送给司机吗？"
      show-cancel-button
      v-on:confirm="onStartNodeReSendGo"
      v-on:cancel="
        showStartNodeReSend = false;
        driverTel = null;
        errorMsg = '';
      "
      :before-close="reSendBeforeClose"
    >
      <van-field
        v-model="driverTel"
        placeholder="请输入手机号码,如不填将默认发送给司机"
        :error-message="errorMsg"
      />
    </van-dialog>

    <textarea id="inputCopy"></textarea>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "合同管理", //标题
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //实时班次GID
      line: JSON.parse(window.localStorage.getItem("line")), //线路名称

      finished: false, //是否已加载完成，加载完成后不再触发load事件
      loading: true, //是否处于加载状态，加载过程中不触发load事件
      ContractList: [], //合同集合

      startNodeUploadFinished: false, //是否已加载完成，加载完成后不再触发load事件
      startNodeUploadLoading: true,
      startNodeUploadList: [], //路单集合

      contracGID: null, //选中的合同GID
      startNodeGID: null, //选中的路单GID
      driverTel: null, //司机号码
      showReSend: false, //是否显示重发短信弹窗
      showStartNodeReSend: false, //是否显示重发短信弹窗
      errorMsg: "", //输入错误提示
      showUploadAttachment: false,
      fileList: [],
      classFileList: [],
    };
  },
  watch: {},
  methods: {
    onCopyUrl(gid, type) {
      let ishttps = "https:" == document.location.protocol ? true : false;
      let url = this.$utils.getSysParams("AdminWebSiteExternalHostOrigin");
      url = url.split(":")[1];
      if (ishttps) {
        url = "https:" + url;
      } else {
        url = "http:" + url;
      }
      if (type == 1) {
        url = url + "/Admin/ContractPreview?GID=" + gid;
      } else {
        url = url + "/Admin/NodeStatement?GID=" + gid;
      }

      var input = document.getElementById("inputCopy");
      input.value = url; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$toast.success("复制成功");
      return false;
    },
    //图片压缩
    afterReadImg(file) {
      //console.log(file);
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (file.file.size > 1000000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 800;
          canvas.height = 600;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 800, 600);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
        };
      }
    },
    //上传附近合同
    uploadAttachment() {
      var that = this;
      this.fileList.forEach(function (file) {
        let params = {
          _JsonText: JSON.stringify({
            ObjectCode: "LineClassDay",
            ObjectGID: that.lineClassDay.GID,
            FileName: "纸质版包车合同图片",
            UrlRelativePath: "",
            UrlAbsolutelPath: "",
            IsValid: true,
            ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
            ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode,
            ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName,
          }),
          base64Content: file.content,
        };
        that.$http
          .post(that.$api.onUploadAttachment, that.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              that.$toast.success("纸质版包车合同图片上传成功");
            }
          });
      });
    },
    //重新发送合同
    onContractReSend(GID) {
      this.contracGID = GID;
      this.showReSend = true;
      this.driverTel = null;
      this.errorMsg = "";
    },
    reSendBeforeClose(action, done) {
      if (action === "confirm") {
        if (this.errorMsg) {
          done(false);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    onContractReSendGo() {
      //手机号正则验证
      if (this.driverTel) {
        if (!this.$utils.isPhone(this.driverTel)) {
          this.errorMsg = "手机号格式错误";
          return false;
        }
      }
      let params = {
        LineClassDayContractGID: this.contracGID,
        NewTel: this.driverTel,
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
      };
      this.$http
        .post(
          this.$api.onLineClassDayContractReSend,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.$toast.success("重新发送成功,请留意查收");
          }
        });
    },
    //重新发送路单
    onStartNodeReSend(GID) {
      this.startNodeGID = GID;
      this.showStartNodeReSend = true;
      this.driverTel = null;
      this.errorMsg = "";
    },
    onStartNodeReSendGo() {
      //手机号正则验证
      if (this.driverTel) {
        if (!this.$utils.isPhone(this.driverTel)) {
          this.errorMsg = "手机号格式错误";
          return false;
        }
      }
      let params = {
        GID: this.startNodeGID,
        NewTel: this.driverTel,
        CompGID: "",
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
        IsResend: false,
      };
      this.$http
        .post(
          this.$api.onLineClassDayNodeStatementMsgSend,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.$toast.success("重新发送成功,请留意查收");
          }
        });
    },
    //合同预览
    onContractView(GID) {
      //兼容https 及 http
      let ishttps = "https:" == document.location.protocol ? true : false;
      let url = this.$utils.getSysParams("AdminWebSiteExternalHostOrigin");
      url = url.split(":")[1];
      if (ishttps) {
        url = "https:" + url + "/Admin/ContractPreview?GID=" + GID;
      } else {
        url = "http:" + url + "/Admin/ContractPreview?GID=" + GID;
      }
      this.$router.push({
        path: "ContractView",
        query: {
          ContractUrl: url,
        },
      });
    },
    //合同查询
    onLineClassDayContractQuery() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
      };
      this.$http
        .post(this.$api.onLineClassDayContractQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.ContractList = res.data;
            this.finished = true;
            this.loading = false;
            this.onLineClassDayAttachmentQuery();
          }
        });
    },
    //电子路单查询
    onLineClassDayStartNodeDataUploadQuery() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
      };
      this.$http
        .post(
          this.$api.onLineClassDayStartNodeDataUploadQuery,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            //每辆车每个班次只显示一条数据
            this.startNodeUploadList = [];
            if (res.data.length > 0) {
              this.startNodeUploadList.push(res.data[0]);
            }
            var flag = false;
            res.data.forEach((item) => {
              this.startNodeUploadList.forEach((v) => {
                if (v.VehicleGID == item.VehicleGID) {
                  flag = true;
                }
              });
              if (!flag) {
                this.startNodeUploadList.push(item);
              }
            });
            this.startNodeUploadFinished = true;
            this.startNodeUploadLoading = false;
          }
        });
    },
    //路单预览
    onStartNodeView(GID) {
      //兼容https 及 http
      let ishttps = "https:" == document.location.protocol ? true : false;
      let url = this.$utils.getSysParams("AdminWebSiteExternalHostOrigin");
      url = url.split(":")[1];
      if (ishttps) {
        url = "https:" + url + "/Admin/NodeStatement?GID=" + GID;
      } else {
        url = "http:" + url + "/Admin/NodeStatement?GID=" + GID;
      }
      this.$router.push({
        path: "StartNodeUploadView",
        query: {
          StatementUrl: url,
        },
      });
    },
    //班次附件查询
    onLineClassDayAttachmentQuery() {
      this.classFileList = [];
      let params = {
        ObjectCode: "LineClassDay",
        ObjectGID: this.lineClassDay.GID,
      };
      this.$http
        .post(
          this.$api.onLineClassDayAttachmentQuery,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              this.classFileList.push({
                url: item.UrlAbsolutelPath,
              });
            });
          }
        });
    },
    //合同删除 取消发车
    onLineClassDayContractDel(GID) {
      this.$dialog
        .confirm({
          message: "确定要删除该合同取消发车吗?",
        })
        .then(() => {
          let params = {
            _JsonText: JSON.stringify({
              GID: GID,
              ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                .GID,
              ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode,
              ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName,
            }),
          };
          this.$http
            .post(
              this.$api.onLineClassDayContractDel,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                this.$toast.success("删除成功,合同内车辆已取消发车");
                this.$router.back(-1);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  mounted: function () {
    this.onLineClassDayContractQuery();
    this.onLineClassDayStartNodeDataUploadQuery();
  },
  created() {},
};
</script>

<style scoped lang="less">
.LineClassPicker {
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}
.infoValue {
  font-size: 16px;
  color: #323233;
}
#inputCopy {
  position: absolute;
  left: -10000px;
  top: -1000px;
}
</style>
